import React, { useEffect } from 'react';
import { StartButton } from '../../../components/Govuk';
import { useMatomo } from '@datapunt/matomo-tracker-react';

export const BeforeStart = () => {
  const { trackPageView, trackEvent } = useMatomo();

  useEffect(() => {
    trackPageView({
      documentTitle: 'Before Starting - Report Suspicious Chemical Activity',
    });
    trackEvent({
      category: 'Before Starting Page',
      action: 'Visited',
    });
  }, []);

  return (
    <div>
      <main
        className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
        id="content"
        role="main"
        tabIndex={0}
      >
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-two-thirds">
            <h1 className="govuk-heading-l" data-test="before-you-start">Before you start</h1>
            <p className="govuk-body">
              This report is sent to the Home Office’s Chemical Reporting Team.
              You are required to report any suspicious incident involving explosive precursors and poisons. 
            </p>
            <p className="govuk-body">
              You have 24 hours from selecting Start now below to submit your report.
              Beyond 24 hours and you will need to start the process again.
            </p>
            <p className="govuk-body">
              It takes between 5 and 15 minutes to complete the form,
              depending on the amount of information you are providing.
            </p>
            <p className="govuk-body">
              You cannot save this form and return to it, so have everything you need before you start
              (for example, your EPP licence holder number).
            </p>
            <h2 className="govuk-heading-m" data-test="regular-reporting-header">
              Evidence
            </h2>
            <p className="govuk-body">
              The form covers the following points:
            </p>
            <ul className="govuk-list govuk-list--bullet">
              <li>description of the products and chemicals</li>
              <li>details of the suspicious person</li>
              <li>payment details</li>
              <li>your crime reference number, if you have one</li>
            </ul>
            <p className="govuk-body">
              If you cannot supply any relevant information, leave the field blank.
            </p>
            <h2 className="govuk-heading-m">Storing evidence</h2>
            <p className="govuk-body">
              The police may follow up on your report or to ask for evidence. Keep any evidence for 6 months.
              For example:
            </p>
            <ul className="govuk-list govuk-list--bullet">
              <li>CCTV records</li>
              <li>receipts</li>
              <li>ID details</li>
              <li>documentation handled by the person</li>
            </ul>
            <h2 className="govuk-heading-m">Support</h2>
            <p className="govuk-body">
              For any questions, contact the Chemical Reporting Team at{' '}
              <a
                className="govuk-link"
                href="mailto:ChemicalReportingTeam@homeoffice.gov.uk"
              >
                ChemicalReportingTeam@homeoffice.gov.uk
              </a>
            </p>
            <p className="govuk-body" style={{ marginBottom: 0 }}>
              The inbox is monitored Monday to Friday, 9am to 5pm (except bank holidays).
            </p>
            <StartButton
              url={'/sar/about-you'}
              dataTest="start-one-off-sar"
              content={"Start now"}
            />
          </div>
        </div>
      </main>
    </div>
  );
};
